import { render, staticRenderFns } from "./PopupsList.vue?vue&type=template&id=20001b2a&scoped=true&"
import script from "./PopupsList.vue?vue&type=script&lang=js&"
export * from "./PopupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20001b2a",
  null
  
)

export default component.exports